import { render, staticRenderFns } from "./standalone-election-vote-component.vue?vue&type=template&id=62a3ed47"
import script from "./standalone-election-vote-component.ts?vue&type=script&lang=ts&external"
export * from "./standalone-election-vote-component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports